import React, { Component } from 'react';

class Footer extends Component {
  render() {
    return (
      <div>
        <footer className="footer">
          <div className="footer-copyright">
            <div>
              <p className="author">
                <i className="fa fa-creative-commons" /> 2017 Paul Hosler
              </p>
              <p className="links">Links</p>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js